// Hex constants taken from the Direction-1 design bundle. Centralized so a
// future migration to Tailwind theme tokens is a single import update.
export const palette = {
  good: '#16a34a',
  goodBg: '#e7f6ec',
  goodInk: '#0e7a37',
  bad: '#dc2626',
  badBg: '#fdecec',
  warn: '#f59e0b',
  warnBg: '#fff4d6',
  warnInk: '#a16207',
  dark: '#0d0d0d',
  hair: '#e8e8e6',
  bgAlt: '#fafaf8',
  muted: '#6b6b6b',
  faint: '#a0a0a0',
  mutedBg: '#f1f1ee',
} as const;

export type Tone = 'good' | 'bad' | 'warn' | 'muted';

export const tonePalette: Record<Tone, { bg: string; fg: string }> = {
  good: { bg: palette.goodBg, fg: palette.goodInk },
  bad: { bg: palette.badBg, fg: palette.bad },
  warn: { bg: palette.warnBg, fg: palette.warnInk },
  muted: { bg: palette.mutedBg, fg: palette.muted },
};
